type GenerateAmountProps = {
  title: string
  amount: number | string
}
export const GenerateAmount = ({ title, amount }: GenerateAmountProps) => {
  return (
    // 🚨 style 추가: 양 끝 정렬 (space-between) 및 수직 중앙 정렬 (center)
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <span>{title}</span>
      <span>{amount} kWh</span>
    </div>
  )
}
